"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var header_dropdown_1 = require("@reverbdotcom/commons/dist/components/header_dropdown");
var news_dropdown_1 = require("./news_dropdown");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var url_helpers_1 = require("../shared/url_helpers");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var CATEGORIES = [
    'electric-guitars',
    'acoustic-guitars',
    'bass-guitars',
    'amps',
    'effects-and-pedals',
    'drums-and-percussion',
    'pro-audio',
    'keyboards-and-synths',
    'dj-and-lighting-gear',
    'pro-audio/microphones',
    'folk-instruments',
    'band-and-orchestra',
    'software',
    'recorded-music',
    'home-audio',
    'accessories',
    'parts',
];
var Headerv2Categories = /** @class */ (function (_super) {
    tslib_1.__extends(Headerv2Categories, _super);
    function Headerv2Categories() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Headerv2Categories.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.resetCategoryScroll);
    };
    Headerv2Categories.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.resetCategoryScroll);
    };
    // Category list scroll position must be reset above mobile sizing
    // otherwise, not all categories will be displayed in the MORE dropdown.
    Headerv2Categories.prototype.resetCategoryScroll = function () {
        if (window.innerWidth <= 640)
            return;
        var categoryScroll = document.querySelector('.site-header__categories__inner');
        categoryScroll.scrollLeft = 0;
    };
    Headerv2Categories.prototype.getOverflowCategories = function () {
        if (!window.document) {
            return [];
        }
        var moreLink = document.querySelector('.site-header__categories__view-more');
        return CATEGORIES.filter(function (cat) {
            var catLink = document.querySelector(".site-header__category [data-header-category=\"" + cat + "\"]");
            if (!catLink || !moreLink)
                return;
            return catLink.getBoundingClientRect().right > moreLink.getBoundingClientRect().left;
        });
    };
    Headerv2Categories.prototype.renderOverflowCategories = function () {
        var _this = this;
        var cats = this.getOverflowCategories();
        if (!cats.length)
            return;
        return cats.map(function (slug) {
            return _this.renderCategoryLink(slug);
        });
    };
    Headerv2Categories.prototype.renderCategories = function () {
        var _this = this;
        return CATEGORIES.map(function (slug) {
            return _this.renderCategoryLink(slug);
        });
    };
    Headerv2Categories.prototype.renderCategoryLink = function (slug) {
        if (slug === 'recorded-music') {
            return (React.createElement("a", { key: slug, className: "site-header__category", href: url_helpers_1.default.lpNewArrivalsUrl() },
                React.createElement("span", { "data-header-category": slug }, I18n.t("discovery.categories." + slug))));
        }
        return (React.createElement(core_link_1.default, { key: slug, className: "site-header__category", activeClassName: "site-header__category--selected", onlyActiveOnIndex: true, to: url_helpers_1.default.cms2PagePath(slug) },
            React.createElement("span", { "data-header-category": slug }, I18n.t("discovery.categories." + slug))));
    };
    Headerv2Categories.prototype.renderViewMoreTrigger = function () {
        return (React.createElement("button", { className: "site-header__categories__view-more" }, I18n.t('discovery.categories.viewMore')));
    };
    Headerv2Categories.prototype.renderViewMore = function () {
        return (React.createElement(header_dropdown_1.default, { trigger: this.renderViewMoreTrigger(), contents: this.renderOverflowCategories(), onOpen: this.props.onOpen, dropdownKey: "more", activeDropdownKey: this.props.activeDropdown }));
    };
    Headerv2Categories.prototype.renderNewsTrigger = function () {
        return (React.createElement(core_link_1.default, { to: "/news", className: "site-header__nav__link site-header__nav__link--articles" }, I18n.t('discovery.navLinks.reverbNews')));
    };
    Headerv2Categories.prototype.renderNavLinks = function () {
        return (React.createElement("ul", { className: "site-header__nav__links" },
            React.createElement("li", { className: "site-header__nav__news" },
                React.createElement(header_dropdown_1.default, { trigger: this.renderNewsTrigger(), contents: React.createElement(news_dropdown_1.default, null), onOpen: this.props.onOpen, dropdownKey: "news", activeDropdownKey: this.props.activeDropdown })),
            React.createElement("li", null,
                React.createElement(core_link_1.default, { to: "/price-guide", className: "site-header__nav__link" }, I18n.t('discovery.navLinks.priceGuide'))),
            React.createElement("li", null,
                React.createElement(core_link_1.default, { to: "/page/reverb-gives", className: "site-header__nav__link" }, I18n.t('discovery.navLinks.reverbGives'))),
            React.createElement("li", null,
                React.createElement(core_link_1.default, { to: "/shops", className: "site-header__nav__link" }, I18n.t('discovery.navLinks.shops')))));
    };
    Headerv2Categories.prototype.render = function () {
        return (React.createElement("div", { className: "site-header__categories" },
            React.createElement("div", { className: "site-header__categories__inner" }, this.renderCategories()),
            this.renderViewMore(),
            this.renderNavLinks()));
    };
    return Headerv2Categories;
}(React.Component));
exports.Headerv2Categories = Headerv2Categories;
exports.default = user_context_provider_1.withUserContext(Headerv2Categories);
//# sourceMappingURL=headerv2_categories.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/new_header/headerv2_categories.js
// module id = akg4
// module chunks = 20 21